<template>
  <div class="login-container">
    <div class="login-form">
      <div class="menuus-logo">
        <img src="@/assets/menuus-logo-with-background.png" alt="Logo" />
      </div>
      <h2 class="mt-4 text-login">Faça login na sua conta</h2>
      <div class="input-container">
        <i class="fas fa-envelope"></i>
        <input
          v-model="email"
          class="email-text-input"
          type="email"
          placeholder="Email"
          @keyup.enter="login"
        />
      </div>
      <div class="input-container">
        <img src="@/assets/lock.svg" alt="lock" class="lock-icon" />
        <input
          v-model="password"
          class="password-text-input"
          :type="passwordFieldType"
          placeholder="Senha"
          @keyup.enter="login"
        />
        <i
          :class="passwordFieldIcon"
          class="password-toggle-icon"
          @click="togglePasswordVisibility"
        ></i>
      </div>
      <!-- TODO: Criar endpoint para enviar email para esqueceu a senha -->
      <!-- <div class="mt-1">
        <router-link to="/forgot-password" class="forgot-password">Esqueci minha senha?</router-link>
      </div> -->
      <button :disabled="!isFormValid" @click="login">Entrar</button>
    </div>
    <div class="login-bg">
      <div class="image-container">
        <img
          src="@/assets/banner-login.svg"
          alt="Login Image"
          class="image-login"
        />
        <div class="text-center">
          <span class="text-footer">Conecte clientes ao seu negócio</span>
          <span class="text-footer-two"
            >Tudo o que você precisa em um painel personalizado</span
          >
        </div>
        <div class="bottom-0 mb-3 position-fixed end-0 me-3">
          <a :href="whatsappLink" target="_blank">
            <img src="@/assets/whatsApp.svg" alt="Whatsapp" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userAuthenticate } from "@/modules/auth/services/auth.customer.service";
import { useToast } from "vue-toastification";
import JwtService from "@/services/jwt";

export default {
  data() {
    return {
      email: "",
      password: "",
      whatsappLink: "https://wa.me/123456789",
      passwordFieldType: "password",
      passwordFieldIcon: "fas fa-eye",
      isLoading: false,
    };
  },
  computed: {
    isFormValid() {
      return this.email && this.password && this.validateEmail(this.email);
    },
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    async login() {
      if (!this.isFormValid || this.isLoading) return;

      const toast = useToast();
      this.isLoading = true;

      try {
        const response = await userAuthenticate(
          this.$store,
          this.email,
          this.password,
        );

        if (response && response.response && response.response.token) {
          const decodedToken = JwtService.parseJwt(response.response.token);

          if (decodedToken) {
            sessionStorage.setItem("userToken", response.response.token);

            if (
              decodedToken.pointOfSales &&
              Array.isArray(decodedToken.pointOfSales)
            ) {
              sessionStorage.setItem(
                "pointOfSales",
                JSON.stringify(decodedToken.pointOfSales),
              );

              // Salvar o primeiro pointOfSale como currentPointOfSale
              if (decodedToken.pointOfSales.length > 0) {
                sessionStorage.setItem(
                  "currentPointOfSale",
                  JSON.stringify(decodedToken.pointOfSales[0]),
                );
              }
            }

            if (decodedToken.user) {
              sessionStorage.setItem(
                "currentUser",
                JSON.stringify(decodedToken.user),
              );
            }
          }

          toast.success("Login efetuado com sucesso!");

          try {
            const pdv = JSON.parse(
              sessionStorage.getItem("currentPointOfSale") || "{}",
            );
            if (pdv?.id) {
              await this.$store.dispatch("onboarding/ensureStatus", {
                pdvId: pdv.id,
                force: true,
              });
            }
          } catch (error) {
            // Falhar aqui só custa o "pisca" — nunca impede o login.
            console.error("Erro ao carregar status de onboarding:", error);
          }

          this.$router.push({ path: "/admin/orders" });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Usuário ou senha incorretos.");
        } else {
          toast.error("Erro ao autenticar. Tente novamente mais tarde.");
        }
      } finally {
        this.isLoading = false;
      }
    },
    togglePasswordVisibility() {
      if (this.passwordFieldType === "password") {
        this.passwordFieldType = "text";
        this.passwordFieldIcon = "fas fa-eye-slash";
      } else {
        this.passwordFieldType = "password";
        this.passwordFieldIcon = "fas fa-eye";
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

.login-container {
  display: flex;
  height: 100vh;
  font-family: "Poppins", sans-serif;
}

.login-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
}

.menuus-logo {
  position: relative;
  top: 1%;
}

.menuus-logo img {
  width: 200px;
}

.input-container {
  position: relative;
  margin-bottom: 10px;
  width: 280px;
}

.input-container i,
.input-container img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #777575;
}

.input-container i.fa-envelope {
  left: 10px;
}

.input-container img.lock-icon {
  left: 10px;
  width: 20px;
  height: 20px;
}

.input-container i.password-toggle-icon {
  right: 10px;
  cursor: pointer;
}

.input-container input {
  width: 100%;
  padding: 10px 40px 10px 35px;
  /* Ajuste de padding para acomodar os ícones */
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-top: 5px;
  box-sizing: border-box;
}

button {
  padding: 10px;
  background-color: #007aff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 280px;
  margin-top: 15px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

button:hover:not(:disabled) {
  background-color: #0458b3;
}

button:active:not(:disabled) {
  background-color: #013770;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.login-bg {
  flex: 1;
  background: linear-gradient(to bottom, #2c70d6, #065ad8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  text-align: center;
}

.login-bg img {
  max-width: 90%;
  max-height: 90%;
}

.text-center {
  margin-top: 20px;
}

.text-footer {
  font-size: 28px;
  display: block;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #ffffff;
}

.text-footer-two {
  font-size: 16px;
  display: block;
  margin-top: 5px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  color: #ffffff;
}

.forgot-password {
  margin-top: 10px;
  text-align: center;
  color: #000000;
  text-decoration: none;
  font-size: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  cursor: pointer;
}

.forgot-password:hover {
  text-decoration: none;
  color: #4180c4;
}

.text-login {
  text-align: center;
  margin-bottom: 20px;
  color: #0c0c0c;
  font-size: 22px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.whatsapp-icon {
  font-size: 3rem;
  color: #25d366;
}

.whatsapp-icon:hover {
  color: #128c7e;
}

.image-login {
  width: 100%;
  object-fit: cover;
}

.email-text-input {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-size: 12px;
}

.password-text-input {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-size: 12px;
}

/* Responsividade para mobile */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .login-bg {
    display: none;
  }

  .login-form {
    width: 100%;
    padding: 20px;
  }

  .input-container {
    width: 85%;
  }

  button {
    width: 85%;
  }

  .menuus-logo {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .menuus-logo img {
    width: 80%;
  }

  .text-login {
    font-size: 24px;
  }
}
</style>
